import {
  VENUES_TAXONOMY_KEY,
  CATERING_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  BANDS_DJS_TAXONOMY_KEY,
  VendorTaxonomyKey,
  GIFT_FAVORS_TAXONOMY_KEY,
  CHILDCARE_SERVICES_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getRecommendedBookingWindow } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';
import {
  getVendorWordSingular,
  getVendorWordPlural,
} from '@zola-helpers/client/dist/es/marketplace/vendorWords';

import _capitalize from 'lodash/capitalize';

export const VENUE_DEK = 'Most couples decide on this first';
export const HAIR_MAKEUP_DEK = "Book 6–9 months out. Don't forget a trial!";
export const CATERER_DEK = "Book 6–9 months out. Don't forget a tasting!";
export const DEFAULT_DEK = 'Book 6–9 months out.';

export const getUnstartedTileDek = (vendorType: VendorTaxonomyKey): string => {
  const planningTime = getRecommendedBookingWindow(vendorType);
  const sentence = `Book ${planningTime} out.`;

  switch (vendorType) {
    case HAIR_MAKEUP_TAXONOMY_KEY:
      return `${sentence} Don't forget a trial!`;
    case VENUES_TAXONOMY_KEY:
      return `${sentence} Most couples decide on this first.`;
    case CATERING_TAXONOMY_KEY:
    case CAKES_DESSERTS_TAXONOMY_KEY:
      return `${sentence} Don't forget a tasting!`;
    default:
      return sentence;
  }
};

export const getVendorTypeName = (vendorType: VendorTaxonomyKey): string => {
  let vendorTypeName = `${_capitalize(getVendorWordSingular(vendorType))}`;

  if (vendorType === CHILDCARE_SERVICES_TAXONOMY_KEY) {
    vendorTypeName = 'Childcare';
  }

  if (vendorType === GIFT_FAVORS_TAXONOMY_KEY) {
    vendorTypeName = 'Gifts and favors';
  }

  if (vendorType === CAKES_DESSERTS_TAXONOMY_KEY) {
    vendorTypeName = 'Cakes and desserts';
  }

  if (vendorType === BANDS_DJS_TAXONOMY_KEY) {
    vendorTypeName = 'Band or DJ';
  }

  return vendorTypeName;
};

export const getLowerCasePluralVendorTypeName = (vendorType: VendorTaxonomyKey): string => {
  let vendorTypeName = `${getVendorWordPlural(vendorType)}`;

  if (vendorType === CHILDCARE_SERVICES_TAXONOMY_KEY) {
    vendorTypeName = 'childcare';
  }

  if (vendorType === GIFT_FAVORS_TAXONOMY_KEY) {
    vendorTypeName = 'gifts and favors';
  }

  if (vendorType === CAKES_DESSERTS_TAXONOMY_KEY) {
    vendorTypeName = 'cakes and desserts';
  }

  if (vendorType === BANDS_DJS_TAXONOMY_KEY) {
    vendorTypeName = 'bands and DJs';
  }

  return vendorTypeName;
};
